import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {Project} from '@app/modules/shared/models';
import {
  getProject,
  getProjectError,
  getProjectSuccessResponse,
  IProjectState,
  ProjectGet
} from '@app/stores';
import { PageShellComponent } from '../../../_components/page-shell/page-shell.component';
import { SbTabsComponent } from '../../../_components/unified/sb-tabs/sb-tabs.component';
import { SbTabDirective } from '../../../_components/unified/sb-tabs/sb-tab.directive';
import { ShareWidgetAccessTabComponent } from './share-widget-access-tab.component';

@Component({
  selector: 'app-influencer-auto-join',
  templateUrl: './influencer-auto-join.component.html',
  styleUrls: ['./influencer-auto-join.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageShellComponent, SbTabsComponent, SbTabDirective, ShareWidgetAccessTabComponent]
})
export class InfluencerAutoJoinComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private projectStore = inject<Store<IProjectState>>(Store);
  private toastr = inject(ToastrService);

  projectId: number;
  readonly project = signal<Project>(null);

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.projectId = Number(this.route.snapshot.paramMap.get('projectId'));
    this.projectStore.pipe(select(getProject), takeUntil(this.destroy$)).subscribe((project) => {
      if (project && Number(project.id) === this.projectId) {
        this.project.set(project);
      }
    });
    this.projectStore.pipe(select(getProjectSuccessResponse), takeUntil(this.destroy$))
      .subscribe((project) => {
        if (project && Number(project.id) === this.projectId) {
          this.project.set(project);
        }
      });
    this.projectStore.pipe(select(getProjectError), takeUntil(this.destroy$)).subscribe((error) => {
      if (error) {
        this.toastr.error(error, 'Error');
      }
    });
    this.projectStore.dispatch(ProjectGet({projectId: this.projectId}));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
